import { render, staticRenderFns } from "./DisciplinaryEdit.vue?vue&type=template&id=89ef2536"
import script from "./DisciplinaryEdit.vue?vue&type=script&lang=js"
export * from "./DisciplinaryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports